
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class ExchangeItqemsSelectGrid extends _Ext.GridBase<ExchangeItemsRow,any> {
        protected getColumnsKey() { return 'Retail.ExchangeItemsSelect'; }
        protected getDialogType() { return <any>ExchangeItemsDialog; }
        protected getIdProperty() { return ExchangeItemsRow.idProperty; }
        protected getLocalTextPrefix() { return ExchangeItemsRow.localTextPrefix; }
        //protected getInsertPermission() { return ExchangeItemsRow.insertPermission; }
        //protected getUpdatePermission() { return ExchangeItemsRow.updatePermission; }
        //protected getDeletePermission() { return ExchangeItemsRow.deletePermission; }
        //protected useViewMode() { return true; } 
        protected getColumns() {
            var _this = this;
            var columns = super.getColumns.call(this);
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(function () { return _this.rowSelection; }));
            return columns;
        };

        constructor(container: JQuery, options) {
            super(container, options);
            this.rowSelection = new Serenity.GridRowSelectionMixin(this);            
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        private autoSize;
        /*
        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            let x;
            ExchangeItemsService.CustomList({
                ContainsText: Exc hangeItemsSelectGrid.ledgerId.toString()
            },
                response =>
                    x = response,
                { async: false });          
            if (ExchangeIte msSelectGrid.ItemType.toString() == "1") {
                ExchangeItemsService.CustomList({
                    ItemTypeIds: [101],
                    LedgerId: Exchang eItemsSelectGrid.ledgerId
                },
                    response =>
                        x = response,
                    { async: false });

            } else if (ExchangeItem sSelectGrid.ItemType.toString() == "2") {
                ExchangeItemsService.CustomList({
                    ItemTypeIds: [104, 105],
                    LedgerId: ExchangeIte msSelectGrid.ledgerId
                },
                    response =>
                        x = response,
                    { async: false });

            }
            for (let rateitem of x.Entities) {
                rateitem[this.getIdProperty()] = rateitem.TransItemId;
                //   alert('ID ' + rateitem.CostId);

                this.view.addItem(rateitem);
            }
            //grid.setData(x1, true);
            //var c = grid.getData();
            
            return grid;
        }
        */
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): ExchangeItemsRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    } 
}